// "2,3,4,5,12" → [2, 3, 4, 5, 12]. Image numbers are the student's page order.
export function parseMissingPages(value) {
  const nums = Array.isArray(value) ? value : String(value || '').split(/[^\d]+/);
  return [...new Set(nums.map((n) => Number(n)).filter((n) => n > 0))].sort((a, b) => a - b);
}

// "2,3,4,5,12" → "2–5, 12". Image numbers are the student's page order.
export function formatMissingImageNumbers(value) {
  const nums = Array.isArray(value)
    ? value
    : String(value || '').split(/[^\d]+/);
  const list = [...new Set(nums.map((n) => Number(n)).filter((n) => n > 0))].sort((a, b) => a - b);
  if (!list.length) return '';
  const parts = [];
  let start = list[0];
  let prev = list[0];
  for (let i = 1; i <= list.length; i++) {
    const n = list[i];
    if (n === prev + 1) {
      prev = n;
      continue;
    }
    parts.push(start === prev ? String(start) : `${start}–${prev}`);
    start = prev = n;
  }
  return parts.join(', ');
}

// Character range of image N in a transcript, including its page header.
// "=== Page N ===" wins, and so does "=== Page N" when the model omits the
// closing marks. A "--- file.jpg ---" marker is used when the transcript
// has no page headers. Without either marker there is no range.
export function pageSpanFromTranscript(text, pageNumber, imageName) {
  const source = String(text || '');
  const page = Number(pageNumber);
  if (!page || page < 1 || !source) return null;
  const pageMarkers = [];
  const pageRe = /^[ \t]*===\s*Page\s+(\d+)(?:\s*===)?[ \t]*$/gim;
  let found;
  while ((found = pageRe.exec(source))) {
    pageMarkers.push({ page: Number(found[1]), start: found.index });
  }
  if (pageMarkers.length) {
    const index = pageMarkers.findIndex((marker) => marker.page === page);
    if (index < 0) return null;
    const start = pageMarkers[index].start;
    const end = index + 1 < pageMarkers.length ? pageMarkers[index + 1].start : source.length;
    return end > start ? { start, end } : null;
  }
  const fileMarkers = [];
  const fileRe = /^[ \t]*---\s*([^\n]*?\.(?:jpe?g|png|webp|gif|bmp|tiff?))\s*---[ \t]*$/gim;
  while ((found = fileRe.exec(source))) {
    fileMarkers.push({ name: found[1].trim(), start: found.index });
  }
  if (!fileMarkers.length) return null;
  const wanted = String(imageName || '').trim().toLowerCase();
  let index = wanted
    ? fileMarkers.findIndex((marker) => marker.name.toLowerCase() === wanted)
    : -1;
  if (index < 0) index = page - 1;
  if (index < 0 || index >= fileMarkers.length) return null;
  const start = fileMarkers[index].start;
  const end = index + 1 < fileMarkers.length ? fileMarkers[index + 1].start : source.length;
  return end > start ? { start, end } : null;
}

// Text under the page header for image N.
export function pageTextFromTranscript(text, pageNumber, imageName) {
  const span = pageSpanFromTranscript(text, pageNumber, imageName);
  if (!span) return '';
  const chunk = String(text || '').slice(span.start, span.end);
  const nl = chunk.indexOf('\n');
  return (nl >= 0 ? chunk.slice(nl + 1) : '').trim();
}

export function ocrMissingFolderTitle(list) {
  return (Array.isArray(list) ? list : [])
    .map((item) => `${item.student} — ${formatMissingImageNumbers(item.pages)}`)
    .filter((line) => !line.endsWith('— '))
    .join('\n');
}
